import React from 'react';
import PropTypes from 'prop-types';
import Selector, { components } from 'react-select';
import _ from 'lodash';

const MenuList = props => {
  const { selectProps } = props;
  return (
    <components.MenuList {...props}>
      <table className="table w-100 mt-n1">
        <thead className="table-light">
          <tr>
            {selectProps.columns.map(x => (
              <th className="text-nowrap text-center w-100 py-1">
                {x.heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{props.children}</tbody>
      </table>
    </components.MenuList>
  );
};

const Option = props => {
  const columns = _.get(props, 'selectProps.columns', []).map(
    col => props.data.value[col.field],
  );
  return (
    <tr
      id={props.innerProps.id}
      ref={props.innerRef}
      className={`${
        (props.isSelected ? 'table-active' : '') +
        (props.isFocused ? ' bg-light' : '')
      } select-option`}
      onClick={() => {
        props.selectOption(props.data);
      }}
    >
      {columns.map(column => (
        <td key={_.uuid()} className="text-nowrap py-1">
          {column}
        </td>
      ))}
    </tr>
  );
};

function ChildSelect(props) {
  const {
    name,
    entity,
    childName,
    isDisabled,
    required,
    value,
    emptyOption,
    placeholder,
    onChange,
  } = props;
  function handleChange(selectedOption) {
    onChange(name, selectedOption.value);
  }

  const options = _.get(entity, childName, []).map(child => ({
    label: child.name,
    value: child,
  }));

  if (emptyOption) {
    options.push(emptyOption);
  }
  return (
    <Selector
      {...props}
      placeholder={placeholder}
      name={name}
      required={required}
      isDisabled={isDisabled}
      value={value}
      onChange={handleChange}
      options={options}
      components={{ MenuList, Option }}
    />
  );
}

ChildSelect.propTypes = {
  name: PropTypes.string.isRequired,
  entity: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  childName: PropTypes.string.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  columns: PropTypes.array,
};

ChildSelect.defaultProps = {
  onChange: () => {},
  isDisabled: false,
  required: false,
  placeholder: 'Välj',
  columns: [{ heading: 'Namn', field: 'name' }],
};

export default ChildSelect;
